export default __webpack_public_path__ + "static/media/rodrigoTripodi.222c3e35.jpg";